export default __webpack_public_path__ + "static/media/Image about IIDEC.8d52ec98.jpg";